import { Play, Lock } from 'lucide-react';

import { Paragraph } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';

interface AudioCardProps {
  title: string;
  isLocked?: boolean;
}

export const AudioCard = ({ title, isLocked }: AudioCardProps) => {
  return (
    <div className="bg-card p-4 rounded-lg shadow-cyan flex justify-between items-center">
      <Paragraph>{title}</Paragraph>
      <div
        className={cn(
          'p-2 rounded-full bg-accent',
          isLocked ? 'bg-secondary text-secondary-foreground' : 'bg-accent'
        )}
      >
        {isLocked ? <Lock /> : <Play />}
      </div>
    </div>
  );
};
